var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.needSidebar)?_c('TheSidebar'):_vm._e(),(_vm.needHeader)?_c('TheHeader'):_vm._e(),_c('v-main',{staticClass:"bc-lightGrey"},[_c('v-container',{class:_vm.containerClass,attrs:{"fluid":""}},[(!_vm.isDataLoaded)?_c('PageLoader'):_vm._e(),_c('router-view')],1)],1),_c('TheSnackbar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }